import '../Styles/TableStyles.css';
import { Component } from 'preact';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import Checkbox from "@material-ui/core/Checkbox";
import Switch from 'preact-material-components/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

class TableComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      flag:0,
      activePage : 1, //pagina activa inicial en pagination
      itemsCountPerPage:50, //items por pagina en pagination
      tableColumns:[], //columnas de tabla
      tableRows:[], //filas de tabla
      data:[], //data total en tabla
      switch:true,
    }
    this.mount_Table = this.mount_Table.bind(this);
    this.update_Table = this.update_Table.bind(this);
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){

    if(this.state.flag==0){
      this.mount_Table(this.props);
      this.setState({flag:1});
    }

    if(!(prevProps.filteredData_projection.length == this.props.filteredData_projection.length) ||
        !(prevProps.filteredData_umap.length == this.props.filteredData_umap.length)){
      this.update_Table(this.props,this.props.filteredData_umap.concat(this.props.filteredData_projection));
    }
  }

  /*
  * Dibujo las columnas de la tabla
  */
  mount_Table(props){
      var tableColumns = [];
      var arrColumns = ['Reference','Sample','Category','SubCategory','Ti','Al','Cr','Fe3','Fe2','Mg',
      'TiO2','Al2O3','Cr2O3','FeO','Fe2O3','MgO',
      'MgAl2O4','FeAl2O4','MgFe2O4','FeFe2O4','MgCr2O4','FeCr2O4','Mg2TiO4','Fe2TiO4'];

      //Completo las columnas
      tableColumns.push(<th>#</th>);
      //tableColumns.push(<th>Remove</th>);
      {Array.from({ length: arrColumns.length }).map((_, index) => (
        tableColumns.push(<th key={index} id={arrColumns[index]}>{arrColumns[index]}</th>)))}
        this.setState({tableColumns:tableColumns});

      const arr = [];
      const arr_filterHigligthed = [];
      var data = props.complete_data;
      var scaleColor = d3.scaleOrdinal()
      .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
      //.range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])
      .range(["#DFFF00","#FFBF00", "#FF7F50", "#DE3163", "#9FE2BF", "#40E0D0","#6495ED", "#CCCCFF"])

      for (let i = 0; i< data.length; i++) {
          arr.push([
            +data[i].i,
            data[i].Ref,
            data[i].Sample,
            data[i].Category1, //Category
            data[i].Category2,//Subcategory
            +data[i].Ti,
            +data[i].Al,
            +data[i].Cr,
            +data[i].Fe3,
            +data[i].Fe2,
            +data[i].Mg,
            +data[i].TiO2,
            +data[i].Al2O3,
            +data[i].Cr2O3,
            +data[i].FeO,
            +data[i].Fe2O3,
            +data[i].MgO,
            +data[i].MgAl2O4,
            +data[i].FeAl2O4,
            +data[i].MgFe2O4,
            +data[i].FeFe2O4,
            +data[i].MgCr2O4,
            +data[i].FeCr2O4,
            +data[i].Mg2TiO4,
            +data[i].Fe2TiO4,
        ]);
      }
      this.setState({data:arr});
    }

    /*
  * Método para resaltar puntos (check button)
  */
  highlightPoints(clase,item){

    var filteredData_projection= this.props.filteredData_projection;
    if(filteredData_projection.includes(item)){
      filteredData_projection = filteredData_projection.filter((i) => i !== item)
      this.props.cbk_filteredData_projection(filteredData_projection);
    }

    var filteredData_umap= this.props.filteredData_umap;
    if(filteredData_umap.includes(item)){
      filteredData_umap = filteredData_umap.filter((i) => i !== item)
      this.props.cbk_filteredData_umap(filteredData_umap);
    }

  }

  update_Table(props,selected_data){
    //Completo las filas
    var row = [];
    var end = this.state.itemsCountPerPage;
    if(selected_data.length<end)
      end = selected_data.length;

    let color;
    let arr = this.state.data;
    var tableRows = [];

    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "hsl(78.26086956521739, 50%,50%)", "hsl(9.130434782608695, 60%,60%)","hsl(124.63768115942028, 50%,50%)", "#304FFF"])

    for(let i = 0; i < end; i++){
        let k = selected_data[i];
        let color = this.props.filteredData_projection.includes(k)? "#FF0000": "#000000" ;
        row.push(<td ><text style={{color:color}}>{arr[k][0]}</text></td>);
        /*row.push(<td>
          <Button variant="outline-dark" style={{border:"none"}} onClick={() => this.highlightPoints(arr[k][2],arr[k][0])}>
              <FontAwesomeIcon icon={faTrashCan} />
          </Button> </td>);*/
        for(let j = 1; j< arr[k].length;j++){
          if(j==3){ //Category (escribo la categoria con el color correspondiente)
            row.push(<td key={i+""+j} style={{color:scaleColor(arr[k][j]),fontWeight:"600"}}> {arr[k][j]}</td>);
          }
          else {
            row.push(<td key={i+""+j} > {arr[k][j]}</td>);
          }
        }

        tableRows.push(<tr key={"f"+i} >{row}</tr>);
        row = [];
    }
    this.setState({tableRows:tableRows});
  }

  /*
  * Modifico las filas visibles en la tabla al seleccionar una pagina nueva del pagination
  */
  handlePageChange(pageNumber) {

    let selected_data =  this.props.filteredData_umap.concat(this.props.filteredData_projection);

    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "hsl(78.26086956521739, 50%,50%)", "hsl(9.130434782608695, 60%,60%)","hsl(124.63768115942028, 50%,50%)", "#304FFF"])

    //Completo las filas
    var row = [];
    let arr = this.state.data;
    var tableRows = [];
    var end = pageNumber*this.state.itemsCountPerPage;
    if(selected_data.length<end)
      end = selected_data.length;

    for(let i = (pageNumber-1)*this.state.itemsCountPerPage; i < end; i++){
      let k = selected_data[i];
      let color = this.props.filteredData_projection.includes(k)? "#FF0000": "#000000" ;
      row.push(<td><text style={{color:color}}>{arr[k][0]}</text></td>);
      //row.push(<td> <Checkbox checked={this.props.filteredData_projection.includes(arr_filterHigligthed[i][0])} onClick={() => this.highlightPoints(arr_filterHigligthed[i][2],arr_filterHigligthed[i][0])} /></td>);
      /*row.push(<td>
        <Button variant="outline-dark" style={{border:"none"}} onClick={() => this.highlightPoints(arr[k][2],arr[k][0])}>
          <FontAwesomeIcon icon={faTrashCan} />
        </Button> </td>);*/

      for(let j = 1; j< arr[k].length;j++){
        if(j==3){ //Category (escribo la categoria con el color correspondiente)
          row.push(<td key={i+""+j} style={{color:scaleColor(arr[k][j]),fontWeight:"600"}}> {arr[k][j]}</td>);
        }
        else {
          row.push(<td key={i+""+j}> {arr[k][j]}</td>);
        }
      }

      tableRows.push(<tr key={"f"+i}>{row}</tr>);
      row = [];
    }

    this.setState({tableRows:tableRows});
    this.setState({activePage: pageNumber});
  }


  render(){
    return (
      <div class="container-Table">
      <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.state.itemsCountPerPage}
      totalItemsCount={this.props.filteredData_umap.length+this.props.filteredData_projection.length}
      pageRangeDisplayed={10}
      onChange={this.handlePageChange.bind(this)}
      onClick={console.log("")}
      />
      <div class="table-responsive-md">

        <Table bordered hover>
        <thead>
        <tr>
        {this.state.tableColumns}
        </tr>
        </thead>
        <tbody>
        {this.state.tableRows}
        </tbody>
        </Table>
      </div>
      </div>
    );
  }

}
export default TableComponent;
/*
<text class="textSwitch switch-table" >Filter selected data</text>

<Switch  class="switch-table switch" checked={this.state.switch} onChange={e =>{this.setState({switch:!this.state.switch},()=>this.update_Table(this.props)); }}/>

*/
